export class ConversationFoldersApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async list() {
        return this.client.get('/api/conversation-folders');
    }
    async create(params) {
        return this.client.post('/api/conversation-folders', params);
    }
    async update(folderId, params) {
        return this.client.patch(`/api/conversation-folders/${encodeURIComponent(folderId)}`, params);
    }
    async addConversation(folderId, conversationId) {
        return this.client.post(`/api/conversation-folders/${encodeURIComponent(folderId)}/conversations`, { conversationId });
    }
    async removeConversation(folderId, conversationId) {
        return this.client.delete(`/api/conversation-folders/${encodeURIComponent(folderId)}/conversations/${encodeURIComponent(conversationId)}`);
    }
    async addSpace(folderId, spaceId) {
        return this.client.post(`/api/conversation-folders/${encodeURIComponent(folderId)}/spaces`, { spaceId });
    }
    async removeSpace(folderId, spaceId) {
        return this.client.delete(`/api/conversation-folders/${encodeURIComponent(folderId)}/spaces/${encodeURIComponent(spaceId)}`);
    }
    async delete(folderId) {
        return this.client.delete(`/api/conversation-folders/${encodeURIComponent(folderId)}`);
    }
}
//# sourceMappingURL=conversation-folders-api.js.map